import React from "react";
import "./Radio.css";

const RadioFont = ({ label, value, onChange, options, withIcon, disabled }) => {
  return (
    <div className="radio">
      {label && <span className="radio-label">{label}</span>}

      <div className={(options.length > 3 ? "radio-component w-[95%]" : "radio-component w-[80%]") + (disabled ? "disabled" : "")}>
        {options?.map((option, index) => {
          return (
            <div
              className={
                (value === option.value ? "activeRadioFont " : "radioItem") +
                " " +
                (option.disabled ? "disabled" : "")
              }
              key={index}
              onClick={() => {
                if (!option.disabled || disabled) onChange(option.value);
              }}
            >
              {withIcon ? (
                <img className={"radio-icon"} src={option.icon} alt="" />
              ) : (
                option.label
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RadioFont;
